import { ReactNode } from "react"

interface IconResizerProps {
    size: number
    color: string
    children: ReactNode
}

function IconResizer(props: IconResizerProps) {
    return (
        <div
            className={props.color}
            style={{
                height: props.size,
                width: props.size
            }}>
            {props.children}
        </div>
    )
}

export default IconResizer
